import type { ChainId } from "web3/constants/chains"
import chains from "web3/constants/chains"
import { chainIdToChainReference } from "web3/helpers/transformers"

type ChainAPI = {
  [K: number]: {
    url: string
    apiKey: string
  }
}

export const CHAIN_APIS: ChainAPI = Object.keys(chains).reduce(
  (result: ChainAPI, key) => {
    const chainData = chains[key as ChainId]
    const indexKey: number = chainIdToChainReference(chainData.id)
    const apiKey =
      chainData.envExplorerArg && chainData.envExplorerArg.length > 0
        ? (process.env[chainData.envExplorerArg] as string)
        : ""

    result[indexKey] = {
      url: chainData?.blockExplorer?.apiUrl ?? "",
      apiKey: apiKey,
    }

    return result
  },
  {},
)
